<div class="wf-exceptions">
  <app-success-toast *ngIf="toastService.showToast"></app-success-toast>

  <div class="wf-exceptions__header">
    <div>
      <h2 class="wf-exceptions__title">Needs Assignment</h2>
      <p class="wf-exceptions__sub">
        Items that stalled because they routed to a role with no assigned users. Use
        <strong>Assign &amp; resume</strong> to staff the missing role — the stalled items then continue
        to that user automatically.
      </p>
    </div>
    <button type="button" class="wf-exceptions__back" (click)="back()">Back to Workflows</button>
  </div>

  <div *ngIf="isLoading" class="wf-exceptions__state">Loading…</div>

  <div *ngIf="!isLoading && loadError" class="wf-exceptions__state wf-exceptions__state--error">
    <span>{{ loadError }}</span>
    <button type="button" (click)="loadExceptions()">Retry</button>
  </div>

  <div *ngIf="!isLoading && !loadError && exceptions.length === 0" class="wf-exceptions__state">
    No items are awaiting assignment — you're all caught up.
  </div>

  <div
    class="wf-exceptions__table-wrap"
    *ngIf="!isLoading && !loadError && exceptions.length > 0"
  >
    <table class="wf-exceptions__table">
    <thead>
      <tr>
        <th>Workflow</th>
        <th>Unfilled role</th>
        <th>Stage</th>
        <th>Flagged</th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let item of exceptions">
        <td>{{ item.name }}</td>
        <td>
          <span class="wf-exceptions__badge">{{ roleLabel(item.currentActorRole) }}</span>
        </td>
        <td>{{ item.currentStageNumber }}</td>
        <td>{{ item.updatedAt | date: 'medium' }}</td>
        <td class="wf-exceptions__actions">
          <button
            type="button"
            class="wf-exceptions__assign"
            (click)="assignUser(item)"
          >
            Assign &amp; resume
          </button>
        </td>
      </tr>
    </tbody>
    </table>
  </div>
</div>
